import { AccessReviewResourceModel } from "models/AccessReviewResourceModel";
import { apiReq } from "utils/api/apiReq";

export const getAccessReviewResource = async (id: string): Promise<AccessReviewResourceModel> => {
  const { data: accessReviewResource } = await apiReq("GET", `/v1/accessReviewResources/${id}`);

  return AccessReviewResourceModel.fromServerData(accessReviewResource);
};
